import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Heading, Icon, Button } from 'components/common/Elements/Elements';
import classes from './ModalWindow.module.scss';

const ModalWindow = ({
  isOpen = false,
  setIsOpen,
  stylesModal = {},
  children,
  headerText
}) => {
  const modalRef = useRef();

  const getFirstLast = () => {
    const focusableModalElements = modalRef.current.querySelectorAll(
      'a[href], button, textarea, input, select'
    );
    const focusableElements = Object.values(focusableModalElements).filter(
      elem => elem.disabled !== true
    );
    return {
      firstElement: focusableElements[0],
      lastElement: focusableElements[focusableElements.length - 1]
    };
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', escFunction);
    } else {
      document.removeEventListener('keydown', escFunction);
    }
    return () => {
      document.removeEventListener('keydown', escFunction);
    };
    // eslint-disable-next-line
  }, [isOpen]);

  const escFunction = e => {
    if (e.code === 'Escape') setIsOpen(false);
    if (e.shiftKey && e.keyCode === 9) {
      const elements = getFirstLast();
      if (document.activeElement === elements.firstElement) {
        elements.lastElement.focus();
        e.preventDefault();
      }
    }
    if (!e.shiftKey && e.keyCode === 9) {
      const elements = getFirstLast();
      if (document.activeElement === elements.lastElement) {
        elements.firstElement.focus();
        e.preventDefault();
      }
    }
  };

  const handleBg = e => {
    if (e.target.id === 'modal') {
      setIsOpen(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className={cn(!stylesModal.bg ? classes.modalBg : stylesModal.bg)}
          id="modal"
          onClick={handleBg}
          role="dialog"
          aria-modal="true"
        >
          <div
            className={cn(
              !stylesModal.body ? classes.modalBody : stylesModal.body
            )}
            ref={modalRef}
          >
            <>
              <Button
                className={classes.clear}
                onClick={() => setIsOpen(false)}
                title="close modal"
              >
                <Icon
                  icon={'closeCircle'}
                  className={classes.icon}
                  size="24px"
                />
              </Button>
              {headerText && (
                <Heading className={classes.title} size={2}>
                  {headerText}
                </Heading>
              )}
              <div
                className={cn(
                  !stylesModal.children
                    ? classes.children
                    : stylesModal.children
                )}
              >
                {children}
              </div>
            </>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalWindow;

ModalWindow.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
  stylesModal: PropTypes.object,
  children: PropTypes.object,
  headerText: PropTypes.string
};
